import type { CSSProperties } from "react";

export const landingTheme = {
  colors: {
    brand: "#469158",
    brandDark: "#3b7f4c",
    brandDeep: "#2f683e",
    brandSoft: "#dcecdf",
    heroFrom: "#173a2b",
    heroVia: "#2f683e",
    heroTo: "#0f2319",
    ink: "#0f172a",
    inkSoft: "#334155",
    muted: "#475569",
    pageBg: "#f5faf6",
    surface: "#ffffff",
    surfaceMuted: "#eef5ef",
    surfaceSoft: "#f7fbf7",
    border: "#d6e4d8",
    footer: "#0d1f16",
    footerMuted: "#9eb2a4",
    onDark: "#ffffff",
    onDarkSoft: "#e8f4ed",
    navBg: "rgba(255, 255, 255, 0.95)",
    glass: "rgba(255, 255, 255, 0.10)",
    glassStrong: "rgba(255, 255, 255, 0.95)",
    glassBorder: "rgba(255, 255, 255, 0.24)",
    softBorderOnDark: "rgba(255, 255, 255, 0.40)",
    footerBorder: "rgba(255, 255, 255, 0.10)",
    glowA: "rgba(255, 255, 255, 0.12)",
    glowB: "rgba(126, 185, 140, 0.28)",
  },
  radii: {
    card: "22px",
    panel: "28px",
    inner: "18px",
    pill: "999px",
  },
  shadows: {
    soft: "0 24px 55px -34px rgba(15, 23, 42, 0.45)",
    card: "0 18px 40px -28px rgba(15, 23, 42, 0.28)",
    button: "0 16px 32px -24px rgba(15, 23, 42, 0.40)",
  },
  fontFamily: '"Montserrat", "Segoe UI", Tahoma, sans-serif',
} as const;

export const landingThemeVars = {
  "--landing-brand": landingTheme.colors.brand,
  "--landing-brand-dark": landingTheme.colors.brandDark,
  "--landing-brand-deep": landingTheme.colors.brandDeep,
  "--landing-brand-soft": landingTheme.colors.brandSoft,
  "--landing-hero-from": landingTheme.colors.heroFrom,
  "--landing-hero-via": landingTheme.colors.heroVia,
  "--landing-hero-to": landingTheme.colors.heroTo,
  "--landing-ink": landingTheme.colors.ink,
  "--landing-ink-soft": landingTheme.colors.inkSoft,
  "--landing-muted": landingTheme.colors.muted,
  "--landing-page-bg": landingTheme.colors.pageBg,
  "--landing-surface": landingTheme.colors.surface,
  "--landing-surface-muted": landingTheme.colors.surfaceMuted,
  "--landing-surface-soft": landingTheme.colors.surfaceSoft,
  "--landing-border": landingTheme.colors.border,
  "--landing-footer": landingTheme.colors.footer,
  "--landing-footer-muted": landingTheme.colors.footerMuted,
  "--landing-on-dark": landingTheme.colors.onDark,
  "--landing-on-dark-soft": landingTheme.colors.onDarkSoft,
  "--landing-nav-bg": landingTheme.colors.navBg,
  "--landing-glass": landingTheme.colors.glass,
  "--landing-glass-strong": landingTheme.colors.glassStrong,
  "--landing-glass-border": landingTheme.colors.glassBorder,
  "--landing-soft-border-on-dark": landingTheme.colors.softBorderOnDark,
  "--landing-footer-border": landingTheme.colors.footerBorder,
  "--landing-glow-a": landingTheme.colors.glowA,
  "--landing-glow-b": landingTheme.colors.glowB,
  "--landing-radius-card": landingTheme.radii.card,
  "--landing-radius-panel": landingTheme.radii.panel,
  "--landing-radius-inner": landingTheme.radii.inner,
  "--landing-radius-pill": landingTheme.radii.pill,
  "--landing-shadow-soft": landingTheme.shadows.soft,
  "--landing-shadow-card": landingTheme.shadows.card,
  "--landing-shadow-button": landingTheme.shadows.button,
  "--landing-font-family": landingTheme.fontFamily,
} as CSSProperties;
